/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChatContext } from './chatContext';

export interface TurnRequest { 
    clientMessageId?: string;
    text?: string;
    context?: ChatContext;
    mode?: TurnRequest.ModeEnum;
}
export namespace TurnRequest {
    export type ModeEnum = 'CLASSIC' | 'MYCHECK' | 'EDIT';
    export const ModeEnum = {
        CLASSIC: 'CLASSIC' as ModeEnum,
        MYCHECK: 'MYCHECK' as ModeEnum,
        EDIT: 'EDIT' as ModeEnum
    };
}